import { asyncLoad } from '@util'
import Home from '@components/LocalMerchant/ZhiTuiBao/Home'
import Introduce from '@components/LocalMerchant/ZhiTuiBao/Introduce'
import Order from '@components/LocalMerchant/ZhiTuiBao/Order'
import Help from '@components/LocalMerchant/ZhiGuangTong/Help'
import jukeBao from './jukeBao'

const Popularization = asyncLoad(() =>
  import('@components/LocalMerchant/Popularization')
)

const Buy = asyncLoad(() => import('@components/LocalMerchant/ZhiTuiBao/Buy'))

const AsyncHome = asyncLoad(() =>
  import('@components/LocalMerchant/ZhiGuangTong/Home')
)

const AsyncRecharge = asyncLoad(() =>
  import('@components/LocalMerchant/ZhiGuangTong/Recharge')
)

const AsyncEditPlan = asyncLoad(() =>
  import('@components/LocalMerchant/ZhiGuangTong/EditPlan')
)
const AsyncPlanData = asyncLoad(() =>
  import('@components/LocalMerchant/ZhiGuangTong/PlanData')
)

const AsyncReward = asyncLoad(() =>
  import('@components/LocalMerchant/ZhiGuangTong/Reward')
)

export default [
  {
    path: 'promoteMarketingPage',
    indexRoute: {
      component: asyncLoad(() =>
        import('@components/LocalMerchant/PromoteMarketingPage')
      )
    },
    stat: '推广中心营销页'
  },
  {
    path: 'popularization',
    component: Popularization,
    stat: '推广中心/首页'
  },
  {
    path: 'zhiTuiBao',
    indexRoute: {
      component: Home
    },
    stat: '智推宝投放设置/首页',
    childRoutes: [
      {
        path: 'introduce',
        component: Introduce,
        stat: '智推宝/智推宝宣传页'
      },
      {
        path: 'order',
        component: Order,
        stat: '智推宝/激活顺序设置'
      },
      {
        path: 'buy',
        component: Buy,
        stat: '智推宝/购买季度套包'
      }
    ]
  },
  {
    path: 'zhiGuangTong',
    indexRoute: {
      component: AsyncHome
    },
    childRoutes: [
      {
        path: 'edit(/:id)',
        component: AsyncEditPlan,
        stat: '智优投/新建推广'
      },
      {
        path: 'recharge',
        component: AsyncRecharge,
        stat: '智优投/充值中心'
      },
      {
        path: 'reward',
        component: AsyncReward,
        stat: '智优投/奖励金'
      },
      {
        path: 'subPlanStat/:id',
        component: AsyncPlanData,
        stat: '智优投/计划数据'
      },
      {
        path: 'help',
        component: Help,
        stat: '智优投/疑问解答'
      }
    ]
  },
  jukeBao
]
